var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"resizable":""}},[_c('navbar',{attrs:{"text":`${_vm.$t('LeftPanel_title_ParcelSystem')} > ${_vm.$t('Page_subtitle_clients')}`}}),_vm._v(" "),_c('DxSystemParcelClients')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }